import Screen from "@/components/layout/Screen";
import { Center } from "@/components/ui/center";
import { Text } from "@/components/ui/text";
import { T } from "@transifex/react";

export default function PurchaseHistory() {
  return (
    <Screen className="flex-1 p-10">
      <Center className={"flex-1"}>
        <Text className="font-bold text-lg text-typography-900">
          <T _str="Coming soon..." />
        </Text>
      </Center>
    </Screen>
  );
}
